import React from 'react';
import { Box, Typography } from '@mui/material';
import { StaticImage } from 'gatsby-plugin-image';
import { DeepseekSvg } from './DeepseekSvg';
import { ChatgptSvg } from './ChatgptSvg';
import { GigachatSvg } from './GigachatSvg';
import { FireSvg } from './FireSvg';
import { PyTorchSvg } from './PyTorchSvg';
import { styles } from './styles';

export const AiCard = ({ program }) => {
  const title =
    program === 'ds'
      ? 'Обучаем как использовать AI в работе дата-сайнтиста'
      : 'Обучаем как использовать AI в работе разработчика';

  const Logos =
    program === 'ds' ? (
      <>
        <ChatgptSvg />
        <StaticImage
          src="./googleBert.png"
          alt="Google BERT"
          layout="fixed"
          width={111}
          height={58}
        />
        <PyTorchSvg />
      </>
    ) : (
      <>
        <DeepseekSvg />
        <ChatgptSvg />
        <GigachatSvg />
      </>
    );

  return (
    <Box sx={styles.aiCard}>
      <Box sx={styles.fireIcon}>
        <FireSvg />
      </Box>
      <Typography
        variant="desktopH3"
        color="kit.text.orange"
        mb="6px"
        mt="-4px"
      >
        NEW
      </Typography>
      <Typography variant="kit.desktopP2" color="#ffffff" mb={4}>
        {title}
      </Typography>
      <Box sx={styles.logos}>{Logos}</Box>
    </Box>
  );
};
